module.exports = __webpack_public_path__ + "static/media/nataplay.7b092c36.JPG";